import noDataImageUrl from "@/assets/no-data-found.svg"
import { BloodGlucoseObservationWithReading } from "@/model"
import { DateTimeFormatter, LocalDate } from "@js-joda/core"
import { Locale } from "@js-joda/locale"
import ReadingCard from "./ReadingCard"

type MeasurementsDashboardProps = {
  observationsByDate: Record<string, BloodGlucoseObservationWithReading[]>
  onReadingCardClick: (observation: BloodGlucoseObservationWithReading) => void
}

const DAY_HEADER_FORMAT = DateTimeFormatter.ofPattern("MMM dd, yyyy").withLocale(Locale.US)

const MeasurementsDashboard = ({
  observationsByDate,
  onReadingCardClick,
}: MeasurementsDashboardProps) => {
  const entries = Object.entries(observationsByDate).sort(([a], [b]) => (a < b ? 1 : -1))

  if (entries.length === 0) {
    return (
      <div className="flex flex-col items-center gap-4 py-8 text-center">
        <img alt="No data found" src={noDataImageUrl} width={240} />
        <h3 className="text-xl font-semibold text-primary-contrast">
          No measurements found for the selected week
        </h3>
      </div>
    )
  }

  return (
    <div className="mt-6 flex flex-col gap-5">
      {entries.map(([date, observations]) => (
        <section key={date} className="flex flex-col gap-3">
          <h3 className="text-lg font-semibold text-primary-contrast">
            {LocalDate.parse(date).format(DAY_HEADER_FORMAT)}
          </h3>
          {observations.map((observation) => (
            <ReadingCard
              key={observation.reading.id}
              observation={observation}
              onClick={onReadingCardClick}
            />
          ))}
        </section>
      ))}
    </div>
  )
}

export default MeasurementsDashboard
